<template>
  <div class="flex-col section_8 space-y-9">
    <div class="flex flex-row justify-between items-start">
      <div class="space-x-9">
        <div v-if="!data.titleHidden" class="font_4">{{ data.title }}</div>
        <div v-if="!data.subtitleHidden" class="font_7" style="margin-left: 0 !important; margin-top: 2px">
          {{ data.subtitle }}
        </div>
      </div>
      <div v-if="data.showMoreButton" class="flex flex-row items-center">
        <span class="font_5 text_14">更多</span>
        <img class="shrink-0 image_7" src="https://ysh-cdn.kaidicloud.com/test/home-page/2024/04/25/5b228aff321d47c18ec1ef371875389c.png" alt="" />
      </div>
    </div>
    <div v-for="demand in dataList" :key="demand.id" class="flex flex-row items-center space-x-9">
      <div class="flex flex-col flex-auto space-y-4">
        <div class="flex flex-row items-center" :class="demand.tarType === DEMAND_TYPE.SUPPLY ? 'space-x-4' : 'space-x-5'">
          <div v-if="demand.tarType === DEMAND_TYPE.SUPPLY" class="flex flex-col justify-start items-center shrink-0 text-wrapper_2">
            <span class="font_8 text_15">{{ DEMAND_TYPE_MAP.get(demand.tarType) }}</span>
          </div>
          <div v-else class="flex flex-col justify-start items-center shrink-0 text-wrapper_3">
            <span class="font_8 text_16">{{ DEMAND_TYPE_MAP.get(demand.tarType) }}</span>
          </div>

          <span class="font_2 line-clamp-1" style="width: 188px">{{ demand.title }}</span>
        </div>
        <div class="flex flex-row items-center space-x-8">
          <span class="font_7">{{ demand.city }}</span>
          <div class="section_9"></div>
          <span class="font_9">合作金额 {{ COOPERATION_AMOUNT_MAP.get(demand.money) }}</span>
        </div>
      </div>
      <img class="shrink-0 image_16 object-cover" :src="demand.coverUrl" alt="" />
    </div>
  </div>
</template>

<script>
import { COOPERATION_AMOUNT, COOPERATION_AMOUNT_MAP, DEMAND_TYPE, DEMAND_TYPE_MAP } from '@/views/preview/constant'

export default {
  props: {
    content: {
      required: true,
      type: Array,
    },
    dataList: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      COOPERATION_AMOUNT,
      COOPERATION_AMOUNT_MAP,
      DEMAND_TYPE,
      DEMAND_TYPE_MAP,
    }
  },
  computed: {
    data() {
      return this.content[0]
    },
  },
  methods: {},
}
</script>

<style lang="less" scoped>
.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.object-cover {
  object-fit: cover;
}
.section_8 {
  padding: 24px;
  background-color: #ffffff;
  border-radius: 16px;
  .space-x-9 {
    & > *:not(:first-child) {
      margin-left: 18px;
    }
    .font_4 {
      font-size: 34px;
      font-family: 'PingFang SC';
      line-height: 48px;
      font-weight: 500;
      color: #222222;
    }
  }
  .font_5 {
    font-size: 24px;
    font-family: 'PingFang SC';
    line-height: 34px;
    color: #999999;
  }
  .text_14 {
    font-size: 26px;
    line-height: 36px;
  }
  .image_7 {
    width: 8px;
    height: 14px;
    margin-left: 8px;
  }
  .space-x-8 {
    & > *:not(:first-child) {
      margin-left: 16px;
    }
    .section_9 {
      background-color: #f0eded;
      width: 2px;
      height: 23px;
    }
    .font_9 {
      font-size: 24px;
      font-family: 'PingFang SC';
      line-height: 34px;
      color: #e77600;
    }
  }
  .space-y-4 {
    & > *:not(:first-child) {
      margin-top: 8px;
    }
    .space-x-4 {
      & > *:not(:first-child) {
        margin-left: 8px;
      }
      .text-wrapper_2 {
        background-color: #0091ff;
        border-radius: 4px;
        width: 56px;
        height: 32px;
        .text_15 {
          font-size: 22px;
          line-height: 32px;
        }
      }
    }
    .space-x-5 {
      & > *:not(:first-child) {
        margin-left: 10px;
      }
      .text-wrapper_3 {
        background-color: #fa6400;
        border-radius: 4px;
        width: 56px;
        height: 32px;
        .text_16 {
          font-size: 22px;
          line-height: 32px;
        }
      }
    }
    .font_8 {
      font-size: 24px;
      font-family: 'PingFang SC';
      line-height: 34px;
      color: #ffffff;
    }
    .font_2 {
      font-size: 28px;
      font-family: 'PingFang SC';
      line-height: 40px;
      color: #222222;
    }
  }
  .font_7 {
    font-size: 24px;
    font-family: 'PingFang SC';
    line-height: 34px;
    color: #666666;
  }
  .image_16 {
    border-radius: 8px;
    width: 180px;
    height: 108px;
  }
}
.space-y-9 {
  & > *:not(:first-child) {
    margin-top: 18px;
  }
}
</style>
